import { render, staticRenderFns } from "./myNumber.vue?vue&type=template&id=1af783dc&scoped=true&"
import script from "./myNumber.vue?vue&type=script&lang=js&"
export * from "./myNumber.vue?vue&type=script&lang=js&"
import style0 from "./myNumber.vue?vue&type=style&index=0&id=1af783dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af783dc",
  null
  
)

export default component.exports